module.exports = __webpack_public_path__ + "db44e89302b0f4c5e536dc5d2aced92c.svg";